import axios from 'axios';
import { API_DOMAIN } from '../../../components/constants';
import { registerSessionReset,sessionTicket,sessionIsCurrent } from '../../../utils/sessionLifecycle';
import { clientErrorPayload } from './clientErrorPrivacy';
import { errorReportingFeatures } from './errorReportingFeatures';
export function createClientErrorReporter({enabled=()=>errorReportingFeatures.enabled,send=(payload,ticket)=>axios.post(`${API_DOMAIN}/system-v1/client-errors`,payload,{__srmErrorReport:true,__srmErrorReportSessionTicket:ticket}),now=()=>Date.now(),signedIn=()=>{ try {return !!localStorage.getItem('accessToken');} catch {return false;} },route=()=>window.location.pathname}={}) {
 let times=[],seen=new Map();
 const reset=()=>{times=[];seen.clear();};
 return {reset,report(error,options={}) {
  try {
  if (Number(error?.response?.status)>=400 && Number(error.response.status)<500) return false;
  if (!enabled() || !signedIn() || options.reportingRequest) return false;
  const payload=clientErrorPayload(error,{route:route(),...options}),key=`${payload.message}\n${payload.stack}`,time=now();
  times=times.filter(at=>time-at<60000); for(const [fingerprint,at] of seen) if(time-at>=60000) seen.delete(fingerprint);
  if(times.length>=10 || (seen.has(key) && time-seen.get(key)<60000)) return false;
  times.push(time);seen.set(key,time);const ticket=sessionTicket();
  // Fire and forget once. Neither a rejected transport nor its error interceptor
  // can recurse; failures never affect the original request or create a popup.
  try { if(sessionIsCurrent(ticket)) Promise.resolve(send(payload,ticket)).catch(()=>{}); } catch { /* No retries. */ }
  return true;
  } catch { return false; }
 }};
}
export const clientErrorReporter=createClientErrorReporter();
registerSessionReset(clientErrorReporter.reset);
